module.exports = __webpack_public_path__ + "static/img/Crait_Resource_12.d3be3c1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20180419/Crait_Resource_12.jpeg
// module id = 257
// module chunks = 1